export default {
    //home.js
    "Our Partners": "Nos partenaires",

    //AdressInput.js
    "type your address": "tapez votre adresse",

    //StoreScreen.js
    "km away": " Km ",
    "Closed 🔴": "Fermée 🔴",
    "Open 🟢": "Ouvert 🟢",

    "Days":"Jours",
    "and":"et",
    "Hours":"Heurs",
    "Minutes":"Minutes",
    "Created From :":"Créé à partir de :",
    "Categories :":"Catégories :",

    //DateModel.js
    "Monday": "Lundi",
    "Tuesday": "Mardi",
    "Wednesday": "Mercredi",
    "Thursday": "Jeudi",
    "Friday": "Vendredi",
    "Saturday": "Samedi",
    "Sunday": "Dimanche",
    "Closed": "Fermé ",
    "Service Hours": "Heures de service",
     "Language":"langue",
    // menu.js
    "Our promos": "Nos promotions",

    //selectoption.js
    "(optional)": "(Optionnel)",
    "Required" : "Obligatoire",
    "select up to" : " sélectionner jusqu'à ",
   // SubmitOrder.js
"select at least":"sélectionner au moin",
"of":"de",
"Quantity":"Quantity",
"change your order": "changez votre ordre",

    //submitOrderPromo.js
    "Finish" : "Terminer",
    "Next":"Suivant",

    //ModelPrincipal.js
    "Email Address" : "Adresse mail",
    // "Continue":"Continuer",
    "Or":"Ou",
    "Continue with Google":"Continuer avec Google",
    "Email does not exist":"Email n'existe pas",

    //ModalSignup.js
    "First Name" : "Prénom",
    "Last Name": "Nom de famille",
    "Email" :"E-mail",
    "Enter Phone Number" : "Entrez le numéro de téléphone",
    "Password":"Mot de passe",
    "Confirm Password":"Confirmez le mot de passe",
    "Passwords do not match":"Les mots de passe ne correspondent pas",
    "Signup": "S'inscrire",
    "Sign up": "S'inscrire",
    "Male" : "Homme",
    "Female" : "Femme",
    "All fields are required" : "tous les champs sont obligatoires",
    "One uppercase":"Une majuscule",
    "One number":"Un chiffre",
    "Min 8 characters":"8 caractères minimum",
    "One special character":"un caractère spécial",

    //ModelLogin.js
    "Login" : "Se connecter",
    "Sign in":"Se connecter",
    "Forget password":"Mot de passe oublié",
    "Add to cart" :"Ajouter au panier",
    "kitchen note":"Note cuisine",
    "Leave an addioonal note about your food ( not too spicy )":"Laissez ici une note pour la préparation (pas piquant...) ",
    // Cart.js
    "Your Order":"Votre commande",
    "Checkout ":"Paiement ",
    "Checkout":"Paiement",
    "tax-exclusive":"HT",
    "ASAP":"dès que possible",
    "By checking this box, you confirm your order to":"En cochant cette case, vous confirmez votre commande chez",
    "This action is irreversible and commits to the purchase as outlined.":"Cette action est irréversible et engage à l’achat tel que décrit.",
    "Minimum order value":"Valeur minimale de la commande",
    " for ":" pour le mode",
    "is ":"est ",

    //checkout.js
    "Contact" : "Contact",
    "Name" : "Nom",
    // "Email": "E-mail",
    "phone number":"numéro de téléphone",
    "Order in Advance":"Commandez à l'avance",
    "Reset":"Réinitialiser",
    "Month D, YYYY HH:MM":" J Mois AAAA HH:MM",
    "Payment Method":"Mode de paiement",
    "Cash":"Espèces",
    "EPT":"TPE",
    "Credit/Debit Card":"Carte de crédit / débit",
    "Place Your Order":"Passez votre commande",
    "Dine-in Fee":"Frais supplémentaires (Sur place)",
    "Takeaway Fee":"Frais supplémentaires (À emporter)",
    "Delivery Fee":"Frais supplémentaires (Livraison)",
    "Dine-in fees":"Frais de Sur place)",
    "Takeaway fee":"Frais à emporter)",
    "Delivery fee":"Frais de livraison",
    "Delivery note":"Note Pour la livraison",
    "Leave a note for your delivery":"Laissez une note pour la livraison ",
     "Your Addresses":"Vos Adresses",
     "Friend":"Ami",
      "Home":"Domicile",
      "Work":"Bureau",
      "Other":"Autres",
      "Note for the delivery man :":"Note pour le livreur",
      " Ex : Building or entry code":" Ex : Batiment, digicode...",
      "Save":"Enregistrer",

    //modalresetPassword.js
    "Email has been send, check your email!":"E-mail a été envoyé, vérifiez votre e-mail !",
    "Resend Email":"Ré-envoyer l'email",
  //firstPage.js
     "All Stores":"Toutes les restaurant",
     'Nearby Stores':"Restaurant à proximité",
//ModelEmailSend.js
// "Email has been send, check your email!":"e-mail a été envoyé, vérifiez votre e-mail !",
// "Resend Email":"Ré-envoyer l'email",
// AllStoresScreen.js
// "All Stores":"Tous les restaurants",
// ModalModes.js
"Select Your Mode" :"Sélectionnez votre mode",
"Yes" :"Oui",
"No":"Non",
 //SelectStore.js
 "Select Store":"Choisi un restaurant",
 "Confirm" : "Confirmer",
 "Delivery":"Livraison",
 "Takeaway":"À Emporter",
 "Dine-in":"Sur Place",

 //  ProductModel
"leave your additional note":"laissez une note additionnelle",
"Additional note":"Note supplémentaire",
"Garnish":"Garniture",

// SubmitOrder.js
// "select at least":"sélectionnez au moins",
// "of":"de",
// "Quantity":"Quantité",



//OrdersHistory
"TIME":"TEMPS",
"MODE":"MODE",
"STATUS":"STATUT",
"PAYMENT":"PAIEMENT",
"TOTAL":"TOTALE",
"VIEW":"VOIR",
"accepted":"accepté",
"ready":"prêt",
"rejected":"rejetée",
"missed":"manquée",
"pending":"En attente",


//OrderHistoryModal.js

"(Without service fees)":"(Sans frais de service)",
"ORDER ID":"ID DE LA COMMANDE",
"Total price":"Prix ​​total",
"Add note":"Ajouter une note",
"Leave your note here":"Laissez votre note ici",
"Order Time":"Temps de commande",
"Schedule Order":"Planifier la commande",
"Minutes":"Minutes",
"Seconds":"Secondes",
"left.":"restantes.",
"We regret to inform you that your order has been Missed":"Nous avons le regret de vous informer que votre commande a été manquée",
"We regret to inform you that your order has been Rejected":"Nous avons le regret de vous informer que votre commande a été rejetée",
"We are pleased to inform you that your order has been Accepted":"Nous sommes heureux de vous informer que votre commande a été acceptée",
"We are pleased to inform you that your order is Ready":"Nous avons le plaisir de vous informer que votre commande est prête",
"Free":"Gratuit",
"By checking this box, you confirm that you are certain about proceeding with this specific order to":"En cochant cette case, vous confirmez que vous êtes certain de procéder à cette commande spécifique à",
"This action is irreversible and commits to the purchase as outlined. Please review your selections carefully before confirming":"Cette action est irréversible et engage l'achat tel que décrit. Veuillez examiner attentivement vos sélections avant de confirmer",
"The restaurant is closed, ASAP mode is not available":"Le restaurant est fermé, le mode ASAP n'est pas disponible.",





"Craving something delicious? Order your favorite meals from our platform and enjoy fast, easy, and reliable food delivery. Discover a wide variety of cuisines, exclusive deals, and hassle-free ordering. Satisfaction guaranteed with every bite.":"Envie de quelque chose de délicieux ? Commandez vos plats préférés sur notre plateforme et profitez d'une livraison rapide, facile et fiable. Découvrez une grande variété de cuisines, des offres exclusives et une commande sans tracas. Satisfaction garantie à chaque bouchée.",
"Get connected with us on social networks":"Connectez-vous avec nous sur les réseaux sociaux",
"Pick your 1st choice":"Choisissez votre 1er choix",
"Previous choices":"Choix précédents",
"Now pick your":"Choisissez maintenant votre",
"choice.":"choix.",
"th":"eme",
"rd":"eme",
"nd":"eme",
"Chosen size":"Taille choisie",
"Cart will be cleared , are you sure":"Le panier sera vidé, êtes-vous sûr",
"From ":"a partir de ",
//new
"Phone Number":"Numéro de téléphone",
  "Add Phone Number":"Ajouter un numéro de téléphone",
  "Enter your phone number":"Entrez votre numéro de téléphone",
  "No payment method selected. Order creation aborted.":"Aucun mode de paiement sélectionné. Création de commande annulée.",
  "Select Time Order":"Sélectionner temps de commande",
  "Your order is waiting for the restaurant's approval.":"Votre commande est en attente d'approbation du restaurant.",
  "Please correct the phone number.":"Veuillez corriger le numéro de téléphone.",
  "Unavailable":"Indisponible",
  "Switching modes will clear your cart.":"Le changement de mode videra votre panier.",
  "Would you like to proceed?":"Souhaitez-vous continuer ?",
  "Enter your Delivery Address":"Entrez votre adresse de livraison",
  "Address Type":"Type d'adresse",
  "Continue":"Continuer",
  "empty":"vide",
  "Coupon not found":"Coupon introuvable",
  "The coupon has expired and is no longer valid":"Le coupon a expiré et n'est plus valide",
  "Coupon is valid and active":"Le coupon est valide et actif",
  "Internal Server Error":"Erreur interne du serveur",
  "Discount coupon":"Remise de coupon",
  "Apply":"Appliquer",
  "Enter coupon":"Entrez le coupon",
  "Have a coupon?":"Vous avez un coupon ?",
  "The coupon has not started yet and is not valid":"Le coupon n'a pas encore commencé et n'est pas valide",
  
// news 
"and will be ready in":"et sera prêt aprés",
"Table number :":"Numéro de table :",
"Enter your table number":"Entrez votre numéro de table",
"Your table number is ":"Votre numéro de table est ",
"Guest mode":"Mode Invite",
"Guest Mode":"Mode Invite",
"Please choose a table number and click on « Apply ».":"Veuillez choisir un numéro de table et cliquez sur « Appliquer ».",
"Thanks for your patience!":"Merci pour votre patience !",
// "empty":"vide",

// Terms Popup 
"By continuing, you accept our":"En continuant, vous acceptez nos",
"General Conditions":"Conditions Générales",
"Privacy Policy":"Politique de confidentialité",
"Terms of Service":"Conditions d'utilisation",

  "terms.title": "Conditions Générales de Vente",
  "terms.section1.title": "1. Objet",
  "terms.section1.content": "Les présentes conditions régissent les ventes effectuées sur la plateforme Eatorder entre les vendeurs partenaires et les acheteurs.",
  "terms.section2.title": "2. Commandes",
  "terms.section2.content": "L’acheteur sélectionne un produit, passe commande et effectue le paiement. Une confirmation est envoyée par e-mail. Le vendeur est responsable de l’expédition et de la livraison.",
  "terms.section3.title": "3. Prix",
  "terms.section3.content": "Tous les prix sont affichés en euros, toutes taxes comprises (TVA incluse). Les frais de livraison sont ajoutés lors du processus de paiement.",
  "terms.section4.title": "4. Paiement",
  "terms.section4.content": "Les paiements sont traités en toute sécurité via <strong>Stripe</strong> et/ou <strong>PayPal</strong>. Aucune information bancaire n’est stockée sur nos serveurs.",
  "terms.section5.title": "5. Livraison",
  "terms.section5.content": "La livraison est assurée par les vendeurs partenaires selon les délais indiqués sur les pages produits.",
  "terms.section6.title": "6. Droit de rétractation",
  "terms.section6.content": "Conformément à la législation en vigueur, les acheteurs disposent d’un délai de 14 jours à compter de la réception pour se rétracter (sauf pour les produits non remboursables).",
  "terms.section7.title": "7. Service Client",
  "terms.section7.content": "Pour toute question ou réclamation, veuillez nous contacter à l’adresse : support@eatorder.com",
  "terms.section8.title": "8. Responsabilité",
  "terms.section8.content": "Eatorder ne saurait être tenu responsable des litiges entre acheteurs et vendeurs. Nous agissons uniquement en tant que plateforme intermédiaire.",
  "terms.section9.title": "9. Droit applicable",
  "terms.section9.content": "Les présentes conditions sont soumises au droit français. En cas de litige, le tribunal compétent sera celui du siège social d’Eatorder.",

  "privacy.title": "Politique de Confidentialité",
  "privacy.intro": "Nous nous engageons à protéger votre vie privée. Cette politique explique comment nous collectons, utilisons, partageons et protégeons vos données personnelles sur notre plateforme Eatorder.",
  "privacy.section1.title": "1. Données Collectées",
  "privacy.section1.items": [
    "Informations d'identification : nom complet, adresse e-mail, numéro de téléphone",
    "Détails de paiement via des prestataires tiers (ex : Stripe, PayPal)",
    "Données de navigation : adresse IP, cookies, pages visitées"
  ],
  "privacy.section2.title": "2. Utilisation des Données",
  "privacy.section2.intro": "Vos données sont utilisées pour :",
  "privacy.section2.items": [
    "Traiter les commandes et gérer les livraisons",
    "Gérer votre compte et vos préférences",
    "Envoyer des notifications et mises à jour (avec consentement)",
    "Améliorer les fonctionnalités et performances du service"
  ],
  "privacy.section2.legal": "<strong>Base légale :</strong> exécution du contrat, consentement de l'utilisateur et intérêt légitime.",
  "privacy.section3.title": "3. Partage des Données",
  "privacy.section3.intro": "Les données sont partagées avec :",
  "privacy.section3.items": [
    "Prestataires de paiement",
    "Fournisseurs de livraison et logistique",
    "Services d'hébergement et d'infrastructure"
  ],
  "privacy.section4.title": "4. Vos Droits",
  "privacy.section4.intro": "Conformément au RGPD, vous avez le droit de :",
  "privacy.section4.items": [
    "Accéder, corriger ou supprimer vos données",
    "Limiter ou vous opposer au traitement de vos données",
    "Transférer vos données à un autre prestataire"
  ],
  "privacy.section4.contact": "Contact : support@eatorder.com",
  "privacy.section5.title": "5. Cookies",
  "privacy.section5.content": "Nous utilisons des cookies pour les fonctionnalités essentielles et l’analyse. Vous pouvez modifier vos préférences de cookies dans votre navigateur.",
  "privacy.section6.title": "6. Sécurité des Données",
  "privacy.section6.content": "Les mesures de sécurité incluent le chiffrement, les restrictions d'accès et les sauvegardes régulières pour protéger vos données.",
  "privacy.section7.title": "7. Conservation des Données",
  "privacy.section7.content": "Les données sont conservées aussi longtemps que nécessaire pour fournir le service et jusqu'à 3 ans après votre dernière activité.",
  "privacy.section8.title": "8. Contact",
  "privacy.section8.content": "Pour toute question ou préoccupation liée à la vie privée, contactez support@eatorder.com.",

  "slogan.main": "Régalez-vous sur EatOrder",
  "slogan.sub": "Là où chaque saveur révèle une expérience unique",

}


